import api from "../api";

export const fetchWatomsDashboardGeneralInfoData = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/dashboard/general-information`);
    return response.data.generalInfo || {};
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
};

export const fetchWatomsDashboardDetailedData = async (year, stage, subject, specialization, from, to, userOrganization) => {
  try {
    const response = await api.get(`/api/v1/watoms/dashboard/${year}/${stage}/${subject}/${specialization}/${from}/${to}/${userOrganization}`);
    return response.data.dashboard || {};
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
}